module.exports = __webpack_public_path__ + "img/selo-ebit-ouro.ca3a203.png";